package xim.poc.game.configuration.v0.tower.entities

import xim.math.Vector3f
import xim.poc.game.cleanup
import xim.poc.game.configuration.MonsterDefinitions
import xim.poc.game.configuration.v0.FloorEntity
import xim.poc.game.configuration.v0.V0MonsterHelper
import xim.poc.game.configuration.v0.constants.mobFriendlyLeafkin

class FriendlyLeafkinEntity(position: Vector3f): FloorEntity {

    private val promise = V0MonsterHelper.spawnMonster(
        monsterDefinition = MonsterDefinitions[mobFriendlyLeafkin],
        position = Vector3f(position),
    )

    override fun update(elapsedFrames: Float) {
    }

    override fun cleanup() {
        promise.cleanup()
    }

}